module.exports = __webpack_public_path__ + "static/media/share.99a8faf6.svg";